export const feedbackApi = (client) => ({
    /** Submit a bug report, feature request, or general feedback item. */
    create: (body) => client.post('/api/v1/feedback', body).then((r) => r.data),
    /** The signed-in user's own submission history. */
    listMine: () => client.get('/api/v1/feedback/mine').then((r) => r.data),
    /** Upload a screenshot BEFORE submit — mirrors the public
     *  location-QR image flow. Stash the returned URL and pass it in
     *  `screenshot_urls` on the following `create()` call. */
    uploadImage: (file) => {
        const form = new FormData();
        form.append('file', file);
        return client.post('/api/v1/feedback/upload-image', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }).then((r) => r.data);
    },
    /** Reply thread on one of the signed-in user's own submissions. */
    listMessages: (id) => client.get(`/api/v1/feedback/${id}/messages`).then((r) => r.data),
    /** Post a reply, optionally with image attachments (upload each via
     *  `uploadImage` first). Only the original submitter can call this —
     *  the server 404s otherwise (same "own it or it doesn't exist" rule
     *  as `listMine`). */
    sendMessage: (id, body, attachmentUrls) => client.post(`/api/v1/feedback/${id}/messages`, {
        body, attachment_urls: attachmentUrls,
    }).then((r) => r.data),
    /** Delete one of your own messages in the thread (soft-delete). */
    deleteMessage: (id, msgId) => client.delete(`/api/v1/feedback/${id}/messages/${msgId}`).then((r) => r.data),
    /** Withdraw a submission entirely — deletes the whole thread. */
    delete: (id) => client.delete(`/api/v1/feedback/${id}`).then((r) => r.data),
});
//# sourceMappingURL=feedback.js.map